import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http'
import { inject } from '@angular/core'
import { Observable } from 'rxjs'
import { StoreSession } from 'src/app/store/store-session'
import { environment } from 'src/environments/environment'

const excludedUrls: string[] = [environment.CDN_APP]

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const store = inject(StoreSession)

  const shouldSkip = excludedUrls.some(url => req.url.includes(url))

  if (req.url.includes('verification/phone')) {
    const reqWithApiKey = req.clone({
      setHeaders: {
        'api-key': environment.API_KEY,
      },
    })

    return next(reqWithApiKey)
  }

  if (shouldSkip) {
    return next(req)
  }

  const accessTokenCognito: string = store.session().accessToken

  const reqWithHeaders = req.clone({
    setHeaders: {
      Authorization: `${accessTokenCognito}`,
      'App-Connection': store.session.user.accountId() || 'not-set',
    },
  })
  return next(reqWithHeaders)
}
